// extracted by mini-css-extract-plugin
export default {"statisticsButton":"styles_statisticsButton__4l2yb","buttonSkeleton":"styles_buttonSkeleton__EiiUL"};